import { combineReducers } from 'redux';

import addressDatasourcesReducer from './addressDatasources';

const myAddressReducer = combineReducers({
  addressDatasourcesReducer
});

export default myAddressReducer;
